import { Injectable } from '@angular/core';
import { sha1 } from 'crypto-hash';
import { ClientConfiguation } from '../_enums/clientConfiguration';
import { CommonService } from './app.common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ClienDivisionsSecurityDTO } from '../_models/settings/settingsModels';

@Injectable()
export class PwnedPasswordService {
  constructor(private http: HttpClient, private common: CommonService, public Loader: NgxSpinnerService) {
         
  }
  
  async isPasswordBreached(password: string, isConfigEnable?: boolean): Promise<boolean> {
    this.Loader.show();
    try {
      if (isConfigEnable === undefined) {
        isConfigEnable = this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.configCheckBreachPassword))
      }
      if (!isConfigEnable) {
        return false;
      }

      const fullHash = (await sha1(password)).toUpperCase();
      const prefix = fullHash.substring(0, 5);
      const suffix = fullHash.substring(5);

      const url = `https://api.pwnedpasswords.com/range/${prefix}`;

      const response = await fetch(url);
      if (!response.ok) {
        console.error(`HIBP API failed: ${response.status}`);
        return false;
      }

      const text = await response.text();
      const lines = text.split('\n');
      for (const line of lines) {
        const [returnedSuffix] = line.trim().split(':');
        if (returnedSuffix.toUpperCase() === suffix) {
          return true;
        }
      }
      return false;
    }
    catch (error) {
      console.error('Error in isPasswordBreached:', error);
      return false;
    }
    finally {
      this.Loader.hide();
    }
  }
  passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
    const password = group.get('password')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return password && confirm && password !== confirm
      ? { passwordMismatch: true }
      : null;
  }

  passwordComplexityValidator(control: AbstractControl, paswordComplexity: ClienDivisionsSecurityDTO): ValidationErrors | null {
    if (!control.value || !paswordComplexity) return null;

    const { minLength, specialChars } = paswordComplexity;

    const regex = new RegExp(
      `^(?=.*[A-Z])(?=.*[0-9])(?=.*[${specialChars}]).{${minLength},}$`
    );

    const hasSpaces = /\s/.test(control.value);
    const isValid = regex.test(control.value) && !hasSpaces;

    return isValid ? null : { invalidPattern: true };
  }
}
